import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { RotateCcw } from "lucide-react";
import Seo from "@/components/Seo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-void text-white flex items-center justify-center px-4 hero-grid">
      <Seo title="Kauf abgebrochen · SCHATTENPSYCHE" siteName="SCHATTENPSYCHE" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="glass rounded-2xl p-10 max-w-md w-full text-center"
        data-testid="payment-cancel-page"
      >
        <img src="/logo.png" alt="Schattenpsyche logo" className="w-16 h-16 rounded-full mx-auto mb-6 ring-1 ring-white/20" />
        <span className="stamp text-xs">Abgebrochen</span>
        <h1 className="font-cinzel text-2xl font-bold mt-5">Kauf abgebrochen</h1>
        <p className="text-slate-400 text-sm mt-3">
          Es wurde nichts berechnet. Die Akte bleibt geöffnet, wann immer du bereit bist.
        </p>
        <Link to="/" data-testid="payment-cancel-home-link" className="glow-btn mt-8 !py-3 text-sm">
          <RotateCcw className="w-4 h-4" />
          Zurück zum Buch
        </Link>
      </motion.div>
    </div>
  );
}
